const TOKEN_KEY = "naezip_to_ac_se";
const LOGIN_ATTEMPT_KEY = "_auth_login_started_at";
const LOGIN_ATTEMPT_TTL_MS = 2 * 60 * 1000;

const isKakaoLoginCallback = () => {
  try {
    return (
      window.location?.pathname === "/analyze/login" &&
      new URLSearchParams(window.location.search).has("code")
    );
  } catch (error) {
    return false;
  }
};

export const getAuthAccessToken = () => {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch (error) {
    return null;
  }
};

export const markLoginAttempt = () => {
  try {
    // localStorage를 써 같은 브라우저의 다른 탭에서 시작한 로그인도 refresh 정리와 경합하지 않는다.
    window.localStorage.setItem(LOGIN_ATTEMPT_KEY, String(Date.now()));
  } catch (error) {
    // 저장소 제한 환경에서는 콜백 URL 자체를 보조 신호로 사용한다.
  }
};

export const finishLoginAttempt = () => {
  try {
    window.localStorage.removeItem(LOGIN_ATTEMPT_KEY);
  } catch (error) {
    // 저장소 접근 실패는 로그인 결과에 영향을 주지 않는다.
  }
};

/**
 * OAuth 콜백 중인 세션은 이전 화면에서 시작된 refresh 실패보다 우선한다.
 * 타임스탬프에 TTL을 둬 로그인 취소 뒤 stale marker가 영구히 정리를 막지 않게 한다.
 */
export const isLoginAttemptActive = () => {
  if (isKakaoLoginCallback()) {
    markLoginAttempt();
    return true;
  }

  try {
    const startedAt = Number(window.localStorage.getItem(LOGIN_ATTEMPT_KEY));
    if (Number.isFinite(startedAt) && startedAt > 0) {
      if (Date.now() - startedAt <= LOGIN_ATTEMPT_TTL_MS) return true;
      finishLoginAttempt();
    }
  } catch (error) {
    // 저장소 접근 실패 시 marker 없음으로 취급한다.
  }
  return false;
};

export const hasSessionChanged = failedToken => {
  const currentToken = getAuthAccessToken();
  return !!currentToken && currentToken !== failedToken;
};

// refresh 시작 당시 세션만 갱신한다. 로그아웃은 토큰 삭제 이전에도 무효화한다.
let refreshGeneration = 0;
let observedWindow;
const observeSessionChanges = () => {
  if (
    typeof window === "undefined" ||
    observedWindow === window ||
    typeof window.addEventListener !== "function"
  )
    return;
  observedWindow = window;
  window.addEventListener("storage", event => {
    if (event.key === null || event.key === TOKEN_KEY) refreshGeneration += 1;
  });
  window.addEventListener("nz-session-change", () => {
    refreshGeneration += 1;
  });
};
export const invalidatePendingRefresh = () => {
  refreshGeneration += 1;
};
export const captureRefreshSession = () => {
  observeSessionChanges();
  return { token: getAuthAccessToken(), generation: refreshGeneration };
};
export const isRefreshSessionCurrent = snapshot =>
  snapshot.generation === refreshGeneration && snapshot.token === getAuthAccessToken();
// 성공한 동일 세션 refresh의 연결만 보존한다. 외부 token 교체/로그아웃은 연결되지 않는다.
const refreshContinuations = [];
export const isRefreshSessionCurrentOrRenewed = snapshot => {
  let current = snapshot;
  for (const continuation of refreshContinuations) {
    if (continuation.from.generation === current.generation && continuation.from.token === current.token) {
      current = continuation.to;
    }
  }
  return isRefreshSessionCurrent(current);
};
export const commitRefreshSession = (snapshot, token) => {
  if (!token || !isRefreshSessionCurrent(snapshot)) return false;
  window.localStorage.setItem(TOKEN_KEY, token);
  if (typeof window.dispatchEvent === "function") {
    window.dispatchEvent(new Event("nz-session-change"));
  }
  refreshContinuations.push({ from: snapshot, to: captureRefreshSession() });
  if (refreshContinuations.length > 20) refreshContinuations.shift();
  return true;
};
